<template>
    <div class="meal--day-container">
        <svg class="icon icon-chart" @click.stop="getMenu">
            <use xlink:href="#icon-chart"></use>
        </svg>

        <strong class="meal--day">Dag {{ fixedDay }}</strong>
        <ul class="meal--day-nutrition-list" v-if="charts.summary">
            <li>
                <strong>Kalorier:</strong>
                <span>{{ round(charts.summary['Energi Kcal']) }} kcal</span>
            </li>
            <li>
                <strong>Kolhydrater:</strong>
                <span>{{ round(charts.summary['Kolhydrater']) }} g</span>
            </li>
            <li>
                <strong>Fett:</strong>
                <span>{{ round(charts.summary['Fett']) }} g</span>
            </li>
            <li>
                <strong>Protein:</strong>
                <span>{{ round(charts.summary['Protein']) }} g</span>
            </li>
        </ul>
    </div>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: {
        id: Number,
        day: Number
    },

    computed: {
        fixedDay: function () {
            return this.day + 1;
        }
    },

    data() {
        return {
            state,
            charts: {},
            chartTitle: ''
        };
    },

    mounted() {
        this.setMenu();
    },

    methods: {
        isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        },

        round(num) {
            if (!this.isFloat(num)) {
                return num;
            }

            return num.toFixed(1);
        },

        setMenu() {
            if (this.id === undefined) return;

            axios
                .get('/recept/api/menu/' + this.id + '/day/' + this.fixedDay)
                .then((response) => {
                    this.charts = response.data;
                    this.chartTitle = 'Näringsvärden: Dag ' + this.fixedDay;
                })
                .catch((error) => {});
        },

        getMenu() {
            this.state.charts = this.charts;
            this.state.chartHeader.title = this.chartTitle;
        }
    }
};
</script>
